<template>
  <div class="dashboard wrap">
    <h1>
      Оперативная сводка по обстановке <br>
      на территории МО г. Южно-Сахалинск
    </h1>
    <div class="d-flex align-center">
      <CurrentDate class="mr-5"></CurrentDate>
      <rir-button
        class="rocky--text amphiris"
        content-width
        transparent
        @click="downloadReport"
      >
        <rir-icon
          class="mr-3"
          icon="insert"
        />
        Скачать отчет
      </rir-button>
    </div>
    <div class="dashboard-page">
      <div
        class="dashboard-page__element"
        v-for="kpi in kpiList"
        :key="kpi.id"
        :class="[`column-${getColumnBlock(kpi)}`]"
      >
        <span class="titanic--text clymenti mb-4">{{ kpi.name }}</span>
        <div
          class="dashboard-page__data"
          >
          <dashboard-card
            v-for="child in kpi.children"
            :key="child.id"
            :kpi="child"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {KpiApi} from '@/api/KpiApi';
import Kpi from "@/models/Kpi";

import CurrentDate from "@/components/CurrentDate";
import DashboardCard from "@/components/DashboardCard";
import CONFIG from '../config';

export default {
  name: 'Dashboard',
  beforeDestroy () {
    clearInterval(this.loadInterval)
  },
  components: {
    DashboardCard,
    CurrentDate
  },
  data () {
    return {
      loadInterval: null,
      kpiList: []
    }
  },
  async mounted () {
    await this.loadKpi();
    this.loadInterval = setInterval(() => {
      this.loadKpi()
    }, CONFIG.DASHBOARD_REFRESH_INTERVAL * 1000);
  },
  methods: {
    getColumnBlock (kpi) {
      const countChild = kpi.children.length
      if (countChild > 3) {
        return 2
      }
      return '1'
    },
    async loadKpi () {
      const kpiList = await KpiApi.getList();
      this.kpiList = []
      this.$nextTick(() => {
        this.kpiList = kpiList.content
            .sort((a, b) => a.order - b.order)
            .map(k => new Kpi(k))
      })
    },
    async downloadReport () {
      await KpiApi.downloadReport()
    }
  }
}
</script>

<style lang="scss">
.dashboard{
  min-height: calc(100vh - 40px);
}
.dashboard-page{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(292px, 1fr));
  grid-gap: 16px;
  grid-auto-flow: dense;
  &__element{
    padding: 20px;
    background-color: #FFFFFF;
    border-radius: 16px;
    &:hover{
      box-shadow: 0 9px 28px rgba(17, 48, 121, 0.18);
    }
    &.column-3{
      grid-column: span 3;
    }
    &.column-2{
      grid-column: span 2;
    }
    &.column-1{
      grid-column: span 1;
    }
  }
  &__data{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(126px, 1fr));
    grid-gap: 20px;
  }
  &__info{
    display: flex;
    flex-direction: column;
  }
  &__link{
    text-decoration: none;
    &:hover{
      color: var(--rir-rocky--hover)!important;
    }
  }
}
</style>
